<template>
  <div class="loading"></div>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style scoped>
.loading {
  background: url('/resource/images/loading.svg') center center no-repeat;
  width: 100%;
  height: 50%;
  min-height: 160px;
}
</style>
